import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import CreditCard from '@material-ui/icons/CreditCard';
import LockOpen from '@material-ui/icons/LockOpen';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatBlock from './StatBlock';
import DashboardRenterBlock from './DashboardRenterBlock';
import BikeIcon from '../Icon/BikeIcon';
import UserIcon from '../Icon/UserIcon';
import { ROLE_ADMIN, ROLE_RENTER } from '../../constants/roles';
import DashboardSiteBlock from './DashboardSiteBlock.jsx';

const styles = () => (
  {
    gridItem: {
      margin: '0.5em 0.2em',
    },
  }
);

export class Dashboard extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    renters: PropTypes.array.isRequired,
    bikes: PropTypes.array.isRequired,
    sites: PropTypes.array.isRequired,
    rents: PropTypes.array.isRequired,
    role: PropTypes.number.isRequired,
  };

  render() {
    let dashboardBlocksTitle;
    let dashboardBlocks;
    let bikeCount;
    let rentCount;
    let turnover;
    let userCount;
    if (this.props.dashboardDatas) {
      // Handle rent stats
      bikeCount = this.props.bikes.length
        ? `${this.props.bikes.length} vélos`
        : 'Aucun vélo';
      rentCount = this.props.dashboardDatas.rent_count
        ? `${this.props.dashboardDatas.rent_count} locations`
        : 'Aucune location';
      turnover = this.props.dashboardDatas.turnover
        ? `${this.props.dashboardDatas.turnover / 100} €`
        : 'Aucun revenu';
      userCount = this.props.dashboardDatas.user_count
        ? `${this.props.dashboardDatas.user_count} utilisateurs`
        : 'Aucun utilisateur';
    }

    if (this.props.role === ROLE_ADMIN && this.props.renters) {
      dashboardBlocksTitle = 'Loueurs';
      // Handle renters
      if (Array.isArray(this.props.renters) && this.props.renters.length) {
        dashboardBlocks = this.props.renters.map((renter) => (
          <DashboardRenterBlock
            {...renter}
            bikes={this.props.bikes.filter(bike => bike.renter_info_id === renter.id)}
            sites={this.props.sites.filter(site => site.renter_info_id === renter.id)}
            key={renter.id}
          />
        ));
      } else {
        dashboardBlocks = <Typography variant="subtitle1">Aucun loueur</Typography>;
      }
    } else if (this.props.role === ROLE_RENTER && this.props.sites) {
      dashboardBlocksTitle = 'Sites';
      if (Array.isArray(this.props.sites) && this.props.sites.length) {
        dashboardBlocks = this.props.sites.map((site) => (
          <DashboardSiteBlock {...site} key={site.id} />
        ));
      } else {
        dashboardBlocks = <Typography variant="subtitle1">Aucun site</Typography>;
      }
    }

    return (
      <div>
        <Typography variant="h6" gutterBottom>Statistiques</Typography>
        <br />
        <Grid
          container spacing={4}
          justifyContent="space-around"
        >
          <StatBlock text={bikeCount} icon={BikeIcon} />
          <StatBlock
            text={rentCount}
            icon={LockOpen}
            lateRents={this.props.rents}
            bikes={this.props.bikes}
            sites={this.props.sites}
            renters={this.props.renters}
          />
          <StatBlock text={turnover} icon={CreditCard} />
          <StatBlock text={userCount} icon={UserIcon} />
        </Grid>
        <br />
        <Typography variant="h6" gutterBottom>{dashboardBlocksTitle}</Typography>
        <br />
        <Grid container spacing={4} justifyContent="space-around">
          {dashboardBlocks}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.jsx